export default __webpack_public_path__ + "static/media/multicolor.cbe04c1c.jpg";